import { useQuery } from '@tanstack/react-query';

import { searchUsers } from 'apis/restaurant-api/merchant-admin/user/api';
import { CampaignsQueryKeys } from 'modules/campaigns/campaignsQueryKeys';

export const useGetCampaignAuthor = ({ authorName, isEnabled }: { authorName: string; isEnabled: boolean }) => {
  const { data: author, isFetching } = useQuery(
    CampaignsQueryKeys.GET_AUTHOR(authorName),
    async () => {
      const { users } = await searchUsers(authorName);
      return users.find(user => user.id === authorName);
    },
    {
      refetchOnWindowFocus: false,
      enabled: isEnabled,
    },
  );

  return { author, isFetching };
};
